(() => {
  const drawer = document.getElementById("faq-search-drawer");
  if (!drawer) return;

  const triggerBtn = document.getElementById("legal-search-open");
  if (!triggerBtn) return;

  const openDrawer = () => drawer.setAttribute("open", "");
  const closeDrawer = () => drawer.removeAttribute("open");

  const setTriggerActive = (isActive) => {
    if (isActive) triggerBtn.setAttribute("data-active", "true");
    if (!isActive) triggerBtn.removeAttribute("data-active");
  };

  const panelIds = [
    "legal-panel-faqs",
    "legal-panel-support",
    "legal-panel-care-services"
  ];

  const panelTitleById = {
    "legal-panel-faqs": "FAQ's",
    "legal-panel-delivery-returns": "Delivery and Returns",
    "legal-panel-care-services": "Care Services"
  };

  // ✅ 6-theme mapping op basis van hoofdnummer (1.x t/m 6.x)
  const themeMapByMainNumber = {
    1: {
      tab: "corporate-information",
      sectionId: "lp-theme-detail-corporate-information",
      prefix: "corp",
      title: "Corporate Information"
    },
    2: {
      tab: "delivery",
      sectionId: "lp-theme-detail-delivery",
      prefix: "del",
      title: "Delivery"
    },
    3: {
      tab: "exchange-returns",
      sectionId: "lp-theme-detail-exchange-returns",
      prefix: "ret",
      title: "Exchange & Returns"
    },
    4: {
      tab: "orders",
      sectionId: "lp-theme-detail-orders",
      prefix: "ord",
      title: "Orders"
    },
    5: {
      tab: "products",
      sectionId: "lp-theme-detail-products",
      prefix: "pro",
      title: "Products"
    },
    6: {
      tab: "services",
      sectionId: "lp-theme-detail-services",
      prefix: "ser",
      title: "Services"
    }
  };

  const getThemeInfoFromQuestionNumber = (questionNumber) => {
    if (!questionNumber) return null;

    const parts = String(questionNumber).split(".");
    const main = parseInt(parts[0], 10);
    const sub = parseInt(parts[1], 10);

    if (!Number.isFinite(main) || !Number.isFinite(sub)) return null;

    const info = themeMapByMainNumber[main];
    if (!info) return null;

    return {
      themeTab: info.tab,
      detailSectionId: info.sectionId,
      accordionId: `${info.prefix}-a${sub}`,
      title: info.title,
      main,
      sub
    };
  };

  const getScrollTop = () => {
    if (typeof window.getProxyScrollTop === "function") return window.getProxyScrollTop();
    return window.scrollY || document.documentElement.scrollTop || 0;
  };

  const setScrollTop = (top, behavior) => {
    const b = behavior || "auto";
    if (typeof window.scrollProxyTo === "function") {
      window.scrollProxyTo(top, b);
      return;
    }
    window.scrollTo({ top, behavior: b });
  };

  const scrollToTop = () => {
    if (typeof window.scrollProxyTo === "function") {
      window.scrollProxyTo(0, "smooth");
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  let isScrolling = false;
  let lastScrollTime = 0;
  const SCROLL_COOLDOWN = 500;

  const throttleScrollToTop = () => {
    const now = Date.now();
    if (isScrolling || (now - lastScrollTime) < SCROLL_COOLDOWN) return false;

    isScrolling = true;
    lastScrollTime = now;

    scrollToTop();

    setTimeout(() => {
      isScrolling = false;
    }, 100);

    return true;
  };

  const closeMobileMenuIfOpen = () => {
    const overlay = document.querySelector('[data-legal-overlay]');
    if (overlay) overlay.setAttribute("data-visible", "false");
    document.body.removeAttribute("data-legal-nav-open");
    const dropdown = document.querySelector('[data-legal-dropdown]');
    if (dropdown) dropdown.setAttribute("data-open", "false");
  };

  const activateFaqPanelById = (panelId) => {
    let key = "";
    if (panelId === "legal-panel-faqs") key = "faqs";
    if (panelId === "legal-panel-support") key = "support";
    if (panelId === "legal-panel-care-services") key = "care-services";
    if (!key) return;

    const tabBtn = document.querySelector('[data-legal-tab="' + key + '"]');
    if (tabBtn) tabBtn.click();
  };

  const makeSnippet = (text, q) => {
    const t = text;
    const qi = t.toLowerCase().indexOf(q);
    if (qi === -1) return t.slice(0, 140) + (t.length > 140 ? "…" : "");
    const start = Math.max(0, qi - 40);
    const end = Math.min(t.length, qi + q.length + 80);
    let snippet = t.slice(start, end);
    if (start > 0) snippet = "…" + snippet;
    if (end < t.length) snippet = snippet + "…";
    return snippet;
  };

  let index = [];
  let isWired = false;
  let hasInitialAnimation = false;
  let contactButton = null;

  const buildIndex = () => {
    index = [];

    panelIds.forEach((id) => {
      const panelEl = document.getElementById(id);
      if (!panelEl) return;

      // ❌ WIJZIGING: verwijder het indexeren van losse nodes (h/p/li) zodat #faqs niet in de search komt
      // const nodes = Array.from(panelEl.querySelectorAll("h1,h2,h3,h4,h5,h6,p,li"));
      // nodes.forEach((node) => {
      //   const text = (node.innerText || "").replace(/\s+/g, " ").trim();
      //   if (!text) return;
      //   index.push({ panelId: id, node, text, __kind: "node" });
      // });

      const accordionSummaries = Array.from(panelEl.querySelectorAll("accordion-disclosure summary, details summary"));
      accordionSummaries.forEach((summary) => {
        const titleText = (summary.innerText || "").replace(/\s+/g, " ").trim();
        if (!titleText) return;

        const details = summary.closest("details");
        const accordionRoot = summary.closest("accordion-disclosure") || (details ? details : null);

        let contentEl = null;
        if (accordionRoot) contentEl = accordionRoot.querySelector(".accordion__content");
        if (!contentEl && details) contentEl = details.querySelector(".accordion__content");
        if (!contentEl && details) {
          const allDivs = Array.from(details.querySelectorAll("div"));
          contentEl = allDivs.length ? allDivs[allDivs.length - 1] : null;
        }

        const contentText = ((contentEl && contentEl.innerText) ? contentEl.innerText : "").replace(/\s+/g, " ").trim();
        const combined = (titleText + " " + contentText).trim();

        // ✅ Nummer uit de titel (bijv. "1.1", "2.3", etc.)
        let questionNumber = "";
        const numberMatch = titleText.match(/^(\d+\.\d+)/);
        if (numberMatch) questionNumber = numberMatch[1];

        // ✅ Theme info afleiden uit het vraagnummer (1..6)
        const themeInfo = getThemeInfoFromQuestionNumber(questionNumber);

        // ✅ WIJZIGING: alleen accordeons met geldige 1.x t/m 6.x meenemen (dus geen #faqs tekstblokken)
        if (!themeInfo) return;

        // Sla het summary element op voor eventueel gebruik
        const summaryElement = summary;

        index.push({
          panelId: id,
          node: summary,
          text: combined || titleText,
          __kind: "accordion",
          __titleText: titleText,
          __exactTitle: titleText.trim(),
          __questionNumber: questionNumber,

          // ✅ NIEUW: juiste koppelingen naar 6 themes
          __themeTab: themeInfo ? themeInfo.themeTab : "",
          __detailSectionId: themeInfo ? themeInfo.detailSectionId : "",
          __accordionId: themeInfo ? themeInfo.accordionId : "",
          __themeTitle: themeInfo ? themeInfo.title : "",

          __contentEl: contentEl,
          __contentHTML: (contentEl && typeof contentEl.innerHTML === "string") ? contentEl.innerHTML : "",
          __contentText: contentText,
          __summaryElement: summaryElement
        });
      });
    });
  };

  const createContactButton = () => {
  if (contactButton) return contactButton;

  const button = document.createElement("button");
  button.type = "button";
  button.id = "legal-search__contact-btn";
  button.className = "legal-search__contact-btn";
  button.textContent = "Contact us";

  button.style.cssText = `
    display: block !important;
    width: calc(100% - 50px) !important;
    background-color: #000000 !important;
    color: #ffffff !important;
    border: none !important;
    padding-block: 20px !important;
    margin: 40px 25px !important;
    text-align: center !important;
    font-weight: 500 !important;
    cursor: pointer !important;
    transition: border .3s cubic-bezier(.39,.575,.565,1),
                box-shadow .3s cubic-bezier(.39,.575,.565,1),
                color .3s cubic-bezier(.39,.575,.565,1),
                background .3s cubic-bezier(.39,.575,.565,1) !important;
    border-radius: 100vmax !important;
    font-family: inherit !important;
    font-size: inherit !important;
    line-height: normal !important;
    position: relative !important;
    z-index: 1 !important;
    align-self: center !important;
  `;

  const setHoverOn = () => {
    button.style.setProperty("box-shadow", "inset 0 0 0 1px #000", "important");
    button.style.setProperty("background-color", "#ffffff", "important");
    button.style.setProperty("color", "#000000", "important");
  };

  const setHoverOff = () => {
    button.style.setProperty("box-shadow", "none", "important");
    button.style.setProperty("background-color", "#000000", "important");
    button.style.setProperty("color", "#ffffff", "important");
  };

  button.addEventListener("mouseenter", setHoverOn);
  button.addEventListener("mouseleave", setHoverOff);

  // werkt ook op touch (mobile)
  button.addEventListener("touchstart", setHoverOn, { passive: true });
  button.addEventListener("touchend", setHoverOff, { passive: true });
  button.addEventListener("touchcancel", setHoverOff, { passive: true });

  // keyboard focus (netjes)
  button.addEventListener("focus", setHoverOn);
  button.addEventListener("blur", setHoverOff);

  button.addEventListener("click", (e) => {
    e.preventDefault();
    finishClose();
  });

  contactButton = button;
  return button;
};

(function () {
  const HOVER_ON = (btn) => {
    btn.style.setProperty("box-shadow", "inset 0 0 0 1px #000", "important");
    btn.style.setProperty("background-color", "#ffffff", "important");
    btn.style.setProperty("color", "#000000", "important");
  };

  const HOVER_OFF = (btn) => {
    btn.style.setProperty("box-shadow", "none", "important");
    btn.style.setProperty("background-color", "#000000", "important");
    btn.style.setProperty("color", "#ffffff", "important");
  };

  const normalize = (btn) => {
    // Als er iets bovenop ligt of pointer-events uit staan, dan krijg je nooit hover
    btn.style.setProperty("pointer-events", "auto", "important");
    btn.style.setProperty("position", "relative", "important");
    btn.style.setProperty("z-index", "2147483647", "important");
  };

  const getBtn = (t) => {
    if (!t) return null;
    if (t.id === "legal-search__contact-btn") return t;
    return t.closest ? t.closest("#legal-search__contact-btn") : null;
  };

  // Works even if element gets replaced/re-rendered
  document.addEventListener(
    "mouseover",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_ON(btn);
    },
    true
  );

  document.addEventListener(
    "mouseout",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_OFF(btn);
    },
    true
  );

  document.addEventListener(
    "focusin",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_ON(btn);
    },
    true
  );

  document.addEventListener(
    "focusout",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_OFF(btn);
    },
    true
  );

  document.addEventListener(
    "touchstart",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_ON(btn);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "touchend",
    (e) => {
      const btn = getBtn(e.target);
      if (!btn) return;
      normalize(btn);
      HOVER_OFF(btn);
    },
    { passive: true, capture: true }
  );
})();



  const animateResultsIn = (resultsEl) => {
    const items = resultsEl.querySelectorAll('.legal-search__result');
    items.forEach((item, index) => {
      item.style.animation = 'none';
      item.offsetHeight;
      item.style.animation = `slideInUp 0.3s ease-out ${index * 0.05}s forwards`;
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
    });
  };

  const animateDetailIn = (detailEl) => {
    detailEl.style.animation = 'none';
    detailEl.offsetHeight;
    detailEl.style.animation = 'slideInUp 0.4s ease-out forwards';
    detailEl.style.opacity = '0';
    detailEl.style.transform = 'translateY(30px)';
  };

  const animateResultsOut = (resultsEl, callback) => {
    const items = Array.from(resultsEl.querySelectorAll('.legal-search__result')).reverse();
    let completed = 0;

    if (items.length === 0) {
      if (callback) setTimeout(callback, 100);
      return;
    }

    items.forEach((item, index) => {
      item.style.animation = 'none';
      item.offsetHeight;
      item.style.animation = `slideOutDown 0.2s ease-in ${index * 0.03}s forwards`;

      item.addEventListener('animationend', function handler() {
        item.removeEventListener('animationend', handler);
        completed++;
        if (completed === items.length && callback) {
          setTimeout(callback, 50);
        }
      }, { once: true });
    });
  };

  const setResultsVisible = (resultsEl, isVisible) => {
    resultsEl.setAttribute("data-visible", isVisible ? "true" : "false");
  };

  const clearResults = (resultsEl) => {
    resultsEl.innerHTML = "";
    resultsEl.removeAttribute("data-mode");
    setResultsVisible(resultsEl, false);
    hasInitialAnimation = false;
  };

  const renderAccordionDetail = (resultsEl, item, q, matches, opts = {}) => {
    const animateIn = opts.animateIn !== false;

    resultsEl.innerHTML = "";
    resultsEl.setAttribute("data-mode", "detail");

    const wrap = document.createElement("div");
    wrap.className = "legal-search__detail";

    const headerRow = document.createElement("div");
    headerRow.className = "legal-search__detailHeader";

    const title = document.createElement("h3");
    title.className = "legal-search__detailTitle";
    title.textContent = item.__titleText || "Result";

    const backBtn = document.createElement("button");
    backBtn.type = "button";
    backBtn.className = "legal-search__detailBack";
    backBtn.textContent = "Back to results";

    headerRow.appendChild(title);
    headerRow.appendChild(backBtn);

    const contentWrap = document.createElement("div");
    contentWrap.className = "legal-search__detailContent";

    if (item.__contentHTML) {
      contentWrap.innerHTML = item.__contentHTML;
    } else if (item.__contentText) {
      const p = document.createElement("p");
      p.textContent = item.__contentText;
      contentWrap.appendChild(p);
    } else {
      const p2 = document.createElement("p");
      p2.textContent = "";
      contentWrap.appendChild(p2);
    }

    const actions = document.createElement("div");
    actions.className = "legal-search__detailActions";

    const openOnPageBtn = document.createElement("button");
    openOnPageBtn.type = "button";
    openOnPageBtn.className = "legal-search__detailOpenOnPage";
    openOnPageBtn.textContent = "Open on page";

    openOnPageBtn.style.cssText = `
      display: block !important;
      width: calc(100% - 50px) !important;
      background-color: #000000 !important;
      color: #ffffff !important;
      border: none !important;
      padding-block: 16px !important;
      margin: 40px 25px !important;
      text-align: center !important;
      font-weight: 500 !important;
      cursor: pointer !important;
      transition: border .3s cubic-bezier(.39, .575, .565, 1), 
                  box-shadow .3s cubic-bezier(.39, .575, .565, 1), 
                  color .3s cubic-bezier(.39, .575, .565, 1), 
                  background .3s cubic-bezier(.39, .575, .565, 1) !important;
      border-radius: 100vmax !important;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: normal !important;
      position: relative !important;
      z-index: 1 !important;
      align-self: center !important;
    `;

    openOnPageBtn.addEventListener('mouseenter', () => {
      openOnPageBtn.style.boxShadow = 'inset 0 0 0 1px #000 !important';
    });

    openOnPageBtn.addEventListener('mouseleave', () => {
      openOnPageBtn.style.boxShadow = '';
    });

    actions.appendChild(openOnPageBtn);

    wrap.appendChild(headerRow);
    wrap.appendChild(contentWrap);
    wrap.appendChild(actions);

    resultsEl.appendChild(wrap);
    setResultsVisible(resultsEl, true);

    if (animateIn) {
      setTimeout(() => animateDetailIn(wrap), 10);
    }

    backBtn.addEventListener("click", () => {
      wrap.style.animation = 'none';
      wrap.offsetHeight;
      wrap.style.animation = 'slideOutDown 0.3s ease-in forwards';

      wrap.addEventListener('animationend', () => {
        renderResults(resultsEl, matches, q, true);
      }, { once: true });
    });

    openOnPageBtn.addEventListener("click", () => {
      finishClose();

      // ✅ Gebruik altijd de 6-theme info op basis van vraagnummer
      const themeTab = item.__themeTab || "corporate-information";
      const detailSectionId = item.__detailSectionId || "";

      // (ongewijzigd) legal tab activeren indien je dat nodig hebt
      activateFaqPanelById(item.panelId);
      closeMobileMenuIfOpen();

      setTimeout(() => {
        let targetSection = null;
        if (detailSectionId) {
          targetSection = document.getElementById(detailSectionId);
        }

        const themeCard = document.querySelector(`[data-theme-tab="${themeTab}"]`);
        if (themeCard) {
          themeCard.click();
        }

        setTimeout(() => {
          if (targetSection && item.__accordionId) {
            let targetAccordion = targetSection.querySelector(`#${item.__accordionId}`);

            if (!targetAccordion) {
              const allAccordions = targetSection.querySelectorAll('accordion-disclosure');
              for (const accordion of allAccordions) {
                const summary = accordion.querySelector('summary');
                if (summary) {
                  const summaryText = (summary.innerText || "").trim();
                  if (summaryText.includes(item.__questionNumber) ||
                      summaryText === item.__exactTitle) {
                    targetAccordion = accordion;
                    break;
                  }
                }
              }
            }

            if (targetAccordion) {
              targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });

              setTimeout(() => {
                const details = targetAccordion.querySelector('details');
                const summary = targetAccordion.querySelector('summary');

                if (details && !details.open) {
                  if (summary) {
                    summary.click();
                  }
                  details.open = true;
                  targetAccordion.classList.add('is-open');
                }
              }, 300);
            }
          }
        }, 500);
      }, 200);
    });
  };

  const renderResults = (resultsEl, items, q, isFromDetail = false) => {
    const shouldAnimate = !hasInitialAnimation && !isFromDetail;

    if (!shouldAnimate) {
      createResults(resultsEl, items, q, false);
      hasInitialAnimation = true;
      return;
    }

    createResults(resultsEl, items, q, true);
    hasInitialAnimation = true;
  };

  const createResults = (resultsEl, items, q, shouldAnimate = false) => {
    resultsEl.innerHTML = "";
    resultsEl.removeAttribute("data-mode");

    if (!items.length) {
      const empty = document.createElement("div");
      empty.className = "legal-search__no-results";
      empty.style.padding = "14px 18px";
      empty.textContent = "No results";
      resultsEl.appendChild(empty);
      setResultsVisible(resultsEl, true);

      const contactBtn = createContactButton();
      const contactBtnClone = contactBtn.cloneNode(true);
      resultsEl.appendChild(contactBtnClone);

      if (shouldAnimate) {
        setTimeout(() => {
          empty.style.animation = 'none';
          empty.offsetHeight;
          empty.style.animation = 'slideInUp 0.4s ease-out forwards';
          empty.style.opacity = '0';
          empty.style.transform = 'translateY(20px)';
        }, 10);
      }
      return;
    }

    items.slice(0, 30).forEach((item, index) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "legal-search__result";

      if (shouldAnimate) {
        btn.style.opacity = '0';
        btn.style.transform = 'translateY(20px)';
      }

      const title = document.createElement("p");
      title.className = "legal-search__resultTitle";

      // ✅ Toon altijd correcte theme titel bij accordeons
      const themeTitle = item.__themeTitle || "";
      if (item.__kind === "accordion" && themeTitle) {
        title.textContent = themeTitle;
      } else {
        title.textContent = panelTitleById[item.panelId] || "Result";
      }

      const snippet = document.createElement("p");
      snippet.className = "legal-search__resultSnippet";
      snippet.textContent = makeSnippet(item.text, q);

      btn.appendChild(title);
      btn.appendChild(snippet);

      btn.addEventListener("click", () => {
        if (item.__kind === "accordion") {
          animateResultsOut(resultsEl, () => {
            renderAccordionDetail(resultsEl, item, q, items, { animateIn: false });
          });
          return;
        }

        const currentTop = getScrollTop();

        activateFaqPanelById(item.panelId);
        closeMobileMenuIfOpen();

        setTimeout(() => {
          setScrollTop(currentTop, "auto");
        }, 0);

        setTimeout(() => {
          if (item.node && item.node.scrollIntoView) {
            item.node.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 80);

        finishClose();
      });

      resultsEl.appendChild(btn);
    });

    const contactBtn = createContactButton();
    const contactBtnClone = contactBtn.cloneNode(true);
    resultsEl.appendChild(contactBtnClone);

    setResultsVisible(resultsEl, true);

    if (shouldAnimate) {
      setTimeout(() => animateResultsIn(resultsEl), 10);
    }
  };

  const wireSearchOnce = () => {
    if (isWired) return;

    const input = drawer.querySelector("#faq-drawer-search-input");
    const clearBtn = drawer.querySelector("#faq-drawer-search-clear");
    const resultsEl = drawer.querySelector("#faq-drawer-search-results");
    if (!input || !clearBtn || !resultsEl) return;

    const setClearVisible = (isVisible) => {
      if (isVisible) clearBtn.setAttribute("data-visible", "true");
      if (!isVisible) clearBtn.removeAttribute("data-visible");
    };

    const searchNow = () => {
      const q = (input.value || "").trim().toLowerCase();

      setClearVisible(!!q);

      if (!q) {
        clearResults(resultsEl);
        return;
      }

      const matches = index.filter((row) => row.text.toLowerCase().indexOf(q) !== -1);

      matches.sort((a, b) => {
        const aTitleHit = (a.__titleText || "").toLowerCase().indexOf(q) !== -1 ? 1 : 0;
        const bTitleHit = (b.__titleText || "").toLowerCase().indexOf(q) !== -1 ? 1 : 0;
        if (aTitleHit !== bTitleHit) return bTitleHit - aTitleHit;
        return 0;
      });

      renderResults(resultsEl, matches, q);
    };

    input.addEventListener("input", searchNow);

    clearBtn.addEventListener("click", () => {
      input.value = "";
      setClearVisible(false);
      clearResults(resultsEl);
      input.focus();
    });

    drawer.addEventListener("click", (e) => {
      const closeBtn = e.target.closest("[data-faq-search-close]");
      if (!closeBtn) return;
      e.preventDefault();
      finishClose();
    });

    drawer.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      finishClose();
    });

    const observer = new MutationObserver(() => {
      if (!drawer.hasAttribute("open")) {
        input.value = "";
        setClearVisible(false);
        clearResults(resultsEl);
        setTriggerActive(false);
        hasInitialAnimation = false;
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ["open"] });

    isWired = true;
  };

  const finishClose = () => {
    closeDrawer();
    setTriggerActive(false);
  };

  document.addEventListener("click", (e) => {
    const open = e.target.closest("[data-faq-search-open]");
    if (!open) return;
    e.preventDefault();

    buildIndex();
    wireSearchOnce();

    setTriggerActive(true);
    openDrawer();

    setTimeout(() => {
      const input = drawer.querySelector("#faq-drawer-search-input");
      const clearBtn = drawer.querySelector("#faq-drawer-search-clear");
      if (clearBtn) clearBtn.removeAttribute("data-visible");
      if (input) input.focus();
    }, 60);
  });

  let lastHash = window.location.hash;

  window.addEventListener("hashchange", () => {
    const currentHash = window.location.hash;

    throttleScrollToTop();

    if (currentHash === lastHash) {
      setTimeout(() => throttleScrollToTop(), 100);
    } else {
      lastHash = currentHash;
      setTimeout(() => throttleScrollToTop(), 100);
    }
  });

  if (window.location.hash) {
    setTimeout(() => throttleScrollToTop(), 300);
  }
})();

// Voeg CSS animaties toe aan de pagina
(function addSearchAnimationsCSS() {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes slideOutDown {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(20px);
      }
    }
    
    .legal-search__result {
      animation-fill-mode: forwards;
    }
    
    .legal-search__detail {
      animation-fill-mode: forwards;
    }
    
    .legal-search__no-results {
      animation-fill-mode: forwards;
    }
    
    /* Contact button styling - alleen voor search results */
    .legal-search__contact-btn {
      display: block !important;
      width: calc(100% - 50px) !important;
      background-color: #000000 !important;
      color: #ffffff !important;
      border: none !important;
      padding-block: 16px !important;
      margin: 40px 25px !important;
      text-align: center !important;
      font-weight: 500 !important;
      cursor: pointer !important;
      transition: border .3s cubic-bezier(.39, .575, .565, 1), 
                  box-shadow .3s cubic-bezier(.39, .575, .565, 1), 
                  color .3s cubic-bezier(.39, .575, .565, 1), 
                  background .3s cubic-bezier(.39, .575, .565, 1) !important;
      border-radius: 100vmax !important;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: normal !important;
      position: relative !important;
      z-index: 1 !important;
      align-self: center !important;
    }
    
    .legal-search__contact-btn:hover {
      box-shadow: inset 0 0 0 1px #000 !important;
    }
    
    /* Detail view styling */
    .legal-search__detailHeader {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      margin-bottom: 30px !important;
      width: 100% !important;
      border-bottom: 1px solid rgba(0, 0, 0, .08) !important;
      padding: 30px 25px !important;
      box-sizing: border-box !important;
    }
    
    .legal-search__detailTitle {
      margin: 0 !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      text-transform: uppercase !important;
      flex: 1 !important;
      text-align: left !important;
    }
    
    .legal-search__detailBack {
      background: none !important;
      border: none !important;
      color: #000 !important;
      cursor: pointer !important;
      font-size: 0.9em !important;
      font-weight: 500 !important;
      padding: 8px 12px !important;
      text-decoration: underline !important;
      text-underline-offset: 3px !important;
      margin-left: auto !important;
      white-space: nowrap !important;
    }
    
    .legal-search__detailBack:hover {
      opacity: 0.7 !important;
    }
    
    .legal-search__detailContent {
      flex: 1 !important;
      overflow-y: auto !important;
      min-height: 0 !important;
      padding: 0 25px 20px 25px !important;
    }
    
    .legal-search__detailActions {
      margin-top: auto !important;
      width: 100% !important;
    }
    
    .legal-search__detailOpenOnPage {
      display: block !important;
      width: calc(100% - 50px) !important;
      background-color: #000000 !important;
      color: #ffffff !important;
      border: none !important;
      padding-block: 16px !important;
      margin: 40px 25px !important;
      text-align: center !important;
      font-weight: 500 !important;
      cursor: pointer !important;
      transition: border .3s cubic-bezier(.39, .575, .565, 1), 
                  box-shadow .3s cubic-bezier(.39, .575, .565, 1), 
                  color .3s cubic-bezier(.39, .575, .565, 1), 
                  background .3s cubic-bezier(.39, .575, .565, 1) !important;
      border-radius: 100vmax !important;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: normal !important;
      position: relative !important;
      z-index: 1 !important;
      align-self: center !important;
    }
    
    .legal-search__detailOpenOnPage:hover {
      box-shadow: inset 0 0 0 1px #000 !important;
    }
    
    #faq-drawer-search-results {
      display: flex !important;
      flex-direction: column !important;
      min-height: 0 !important;
      flex: 1 !important;
      padding-bottom: 0 !important;
    }
    
    .legal-search__no-results {
      flex: 1 !important;
    }
    
    /* Detail view container */
    #faq-drawer-search-results[data-mode="detail"] {
      overflow: hidden !important;
    }
    
    .legal-search__detail {
      display: flex !important;
      flex-direction: column !important;
      height: 100% !important;
      min-height: 0 !important;
      width: 100% !important;
    }
    
    /* Custom scrollbar voor detail content */
    .legal-search__detailContent::-webkit-scrollbar {
      width: 5px !important;
    }
    
    .legal-search__detailContent::-webkit-scrollbar-track {
      background: #f1f1f1 !important;
      border-radius: 10px !important;
    }
    
    .legal-search__detailContent::-webkit-scrollbar-thumb {
      background: #888 !important;
      border-radius: 10px !important;
    }
    
    .legal-search__detailContent::-webkit-scrollbar-thumb:hover {
      background: #555 !important;
    }
  `;
  document.head.appendChild(style);
})();

// De rest van je bestaande code voor lpThemesToOneAnimatedBlock blijft hetzelfde...
(function () {
  function initLpThemesToOneAnimatedBlock() {
    var roots = document.querySelectorAll('[data-lp-themes-root]');
    if (!roots || !roots.length) return;

    if (!window.__lpFaqsResetFns) window.__lpFaqsResetFns = [];

    function initOne(root) {
      var startView = root.querySelector('#lp-faqs-start');
      var detailView = root.querySelector('#lp-faqs-detail');
      var detailBlock = root.querySelector('#lp-faqs-detail-block');
      var detailRight = root.querySelector('#lp-faqs-detail-right');
      var detailPanelsRoot = root.querySelector('#lp-theme-detail-panels');
      var backBtn = root.querySelector('#lp-faqs-detail-back');
      var titleEl = root.querySelector('#lp-faqs-detail-title');
      if (!startView || !detailView || !detailBlock || !detailPanelsRoot || !detailRight) return;

      var cards = root.querySelectorAll('[data-theme-tab]');
      var panels = detailPanelsRoot.querySelectorAll('[data-theme-panel]');
      var duration = 250;
      var switching = false;

      function scrollToTop() {
        if (typeof window.scrollProxyTo === "function") {
          window.scrollProxyTo(0, "smooth");
          return;
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      var isScrolling = false;
      var lastScrollTime = 0;
      var SCROLL_COOLDOWN = 500;

      function throttleScrollToTop() {
        var now = Date.now();
        if (isScrolling || (now - lastScrollTime) < SCROLL_COOLDOWN) return false;

        isScrolling = true;
        lastScrollTime = now;

        scrollToTop();

        window.setTimeout(function () {
          isScrolling = false;
        }, 100);

        return true;
      }

      function setPanelsFreeze(isOn) {
        if (!detailPanelsRoot) return;
        if (isOn) detailPanelsRoot.setAttribute('data-freeze', 'true');
        if (!isOn) detailPanelsRoot.removeAttribute('data-freeze');
      }

      function closeOpenAccordionsInside(rootEl) {
        if (!rootEl) return;

        rootEl.querySelectorAll('accordion-disclosure.is-open').forEach(function (accordion) {
          var details = accordion.querySelector('details');
          var summary = accordion.querySelector('summary');

          if (details && details.open && summary) summary.click();
          if (details && details.open) details.open = false;

          accordion.classList.remove('is-open');
        });

        rootEl.querySelectorAll('details[open]').forEach(function (d) {
          d.open = false;
        });
      }

      function resetAllPanels() {
        for (var i = 0; i < panels.length; i++) {
          panels[i].setAttribute('data-active', 'false');
          panels[i].removeAttribute('data-panel-state');
        }
      }

      function getPanelByKey(key) {
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].getAttribute('data-theme-panel') === key) return panels[i];
        }
        return null;
      }

      function getCurrentPanel() {
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].getAttribute('data-active') === 'true') return panels[i];
        }
        return null;
      }

      function setSelectedCard(key) {
        for (var i = 0; i < cards.length; i++) {
          var isActive = cards[i].getAttribute('data-theme-tab') === key;
          cards[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      }

      function setTitleFromCard(key) {
        if (!titleEl) return;

        for (var i = 0; i < cards.length; i++) {
          if (cards[i].getAttribute('data-theme-tab') === key) {
            var t = cards[i].querySelector('.lp-theme-text');
            if (t) {
              titleEl.textContent = t.textContent;
              return;
            }
          }
        }
      }

      function showCorrectPanelImmediately(key) {
        var next = getPanelByKey(key);
        if (!next) return;

        setPanelsFreeze(true);
        resetAllPanels();
        next.setAttribute('data-active', 'true');
        next.removeAttribute('data-panel-state');
        closeOpenAccordionsInside(detailPanelsRoot);
        window.setTimeout(function () {
          setPanelsFreeze(false);
        }, 0);
      }

      function animateStartLeaving(cb) {
        startView.setAttribute('data-view-state', 'leaving');

        window.setTimeout(function () {
          startView.setAttribute('data-active', 'false');
          startView.setAttribute('data-view-state', '');
          if (typeof cb === 'function') cb();
        }, duration);
      }

      function animateStartEntering(cb) {
        startView.setAttribute('data-active', 'true');

        startView.setAttribute('data-view-state', 'entering');
        startView.offsetHeight;
        startView.setAttribute('data-view-state', '');

        window.setTimeout(function () {
          if (typeof cb === 'function') cb();
        }, duration);
      }

      function animateDetailEntering(cb) {
        detailView.setAttribute('data-active', 'true');

        detailBlock.setAttribute('data-view-state', 'entering');
        detailRight.setAttribute('data-view-state', 'entering');

        detailBlock.offsetHeight;
        detailRight.offsetHeight;

        detailBlock.setAttribute('data-view-state', '');
        detailRight.setAttribute('data-view-state', '');

        window.setTimeout(function () {
          if (typeof cb === 'function') cb();
        }, duration);
      }

      function animateDetailLeaving(cb) {
        detailBlock.setAttribute('data-view-state', 'leaving');
        detailRight.setAttribute('data-view-state', 'leaving');

        window.setTimeout(function () {
          detailView.setAttribute('data-active', 'false');
          detailBlock.setAttribute('data-view-state', '');
          detailRight.setAttribute('data-view-state', '');
          if (typeof cb === 'function') cb();
        }, duration);
      }

      function forceResetToStart() {
        setPanelsFreeze(true);
        closeOpenAccordionsInside(detailPanelsRoot);

        detailView.setAttribute('data-active', 'false');
        detailBlock.setAttribute('data-view-state', '');
        detailRight.setAttribute('data-view-state', '');

        startView.setAttribute('data-active', 'true');
        startView.setAttribute('data-view-state', '');

        resetAllPanels();

        window.setTimeout(function () {
          setPanelsFreeze(false);
        }, 0);

        throttleScrollToTop();
      }

      // ✅ per instance reset registreren (geen globale overwrite meer)
      window.__lpFaqsResetFns.push(forceResetToStart);

      function switchPanelWithAnimation(key, cb) {
        var next = getPanelByKey(key);
        if (!next) return;

        var current = getCurrentPanel();
        if (current === next) {
          if (typeof cb === 'function') cb();
          return;
        }

        setPanelsFreeze(true);
        closeOpenAccordionsInside(detailPanelsRoot);

        detailBlock.setAttribute('data-view-state', 'leaving');
        detailRight.setAttribute('data-view-state', 'leaving');

        window.setTimeout(function () {
          resetAllPanels();
          next.setAttribute('data-active', 'true');
          next.removeAttribute('data-panel-state');

          window.setTimeout(function () {
            setPanelsFreeze(false);
          }, 0);

          detailBlock.setAttribute('data-view-state', 'entering');
          detailRight.setAttribute('data-view-state', 'entering');

          detailBlock.offsetHeight;
          detailRight.offsetHeight;

          detailBlock.setAttribute('data-view-state', '');
          detailRight.setAttribute('data-view-state', '');

          window.setTimeout(function () {
            if (typeof cb === 'function') cb();
          }, duration);
        }, duration);
      }

      function hasCardKey(key) {
        if (!key) return false;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].getAttribute('data-theme-tab') === key) return true;
        }
        return false;
      }

      function goToTheme(key) {
        if (!key) return;
        if (!hasCardKey(key)) return;

        if (switching) return;
        switching = true;

        throttleScrollToTop();

        setSelectedCard(key);
        setTitleFromCard(key);

        var isStartActive = startView.getAttribute('data-active') !== 'false';
        var isDetailActive = detailView.getAttribute('data-active') === 'true';

        if (isStartActive) {
          showCorrectPanelImmediately(key);
          animateStartLeaving(function () {
            animateDetailEntering(function () {
              switching = false;
            });
          });
          return;
        }

        if (isDetailActive) {
          switchPanelWithAnimation(key, function () {
            switching = false;
          });
          return;
        }

        showCorrectPanelImmediately(key);
        animateDetailEntering(function () {
          switching = false;
        });
      }

      function goBackToStart(shouldScrollTop) {
        if (switching) return;
        switching = true;

        if (shouldScrollTop) throttleScrollToTop();

        setPanelsFreeze(true);
        closeOpenAccordionsInside(detailPanelsRoot);

        animateDetailLeaving(function () {
          resetAllPanels();
          window.setTimeout(function () {
            setPanelsFreeze(false);
          }, 0);

          animateStartEntering(function () {
            switching = false;
          });
        });
      }

      for (var i = 0; i < cards.length; i++) {
        cards[i].addEventListener('click', function (e) {
          e.preventDefault();

          throttleScrollToTop();

          var key = this.getAttribute('data-theme-tab');
          goToTheme(key);
          history.pushState(null, '', '#' + key);
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          throttleScrollToTop();
          goBackToStart(true);
          history.pushState(null, '', window.location.pathname);
        });
      }

      window.addEventListener('popstate', function () {
        throttleScrollToTop();
        var hash = window.location.hash.replace('#', '');
        if (hash) goToTheme(hash);
        else goBackToStart(true);
      });

      if (window.location.hash) {
        var initialKey = window.location.hash.replace('#', '');
        if (hasCardKey(initialKey)) {
          goToTheme(initialKey);
        }
      }
    }

    for (var r = 0; r < roots.length; r++) {
      initOne(roots[r]);
    }

    (function wireLegalTabsResetToStart() {
      if (window.__lpFaqsLegalTabsWired) return;
      window.__lpFaqsLegalTabsWired = true;

      var legalTabButtons = document.querySelectorAll('[data-legal-tab]');
      if (!legalTabButtons || !legalTabButtons.length) return;

      var activeKey = "";
      for (var i2 = 0; i2 < legalTabButtons.length; i2++) {
        if (legalTabButtons[i2].getAttribute('aria-selected') === 'true') {
          activeKey = legalTabButtons[i2].getAttribute('data-legal-tab') || "";
          break;
        }
      }

      function resetOldTabIfNeeded(nextKey) {
        if (!nextKey) return;
        if (!activeKey) {
          activeKey = nextKey;
          return;
        }
        if (activeKey === nextKey) return;

        if (window.__lpFaqsResetFns && window.__lpFaqsResetFns.length) {
          for (var i = 0; i < window.__lpFaqsResetFns.length; i++) {
            if (typeof window.__lpFaqsResetFns[i] === "function") {
              window.__lpFaqsResetFns[i]();
            }
          }
        }

        activeKey = nextKey;
      }

      for (var i3 = 0; i3 < legalTabButtons.length; i3++) {
        legalTabButtons[i3].addEventListener('click', function () {
          var nextKey = this.getAttribute('data-legal-tab') || "";
          resetOldTabIfNeeded(nextKey);
        });
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLpThemesToOneAnimatedBlock);
  } else {
    initLpThemesToOneAnimatedBlock();
  }
})();

(() => {
  const themeMapByMainNumber = {
    1: { tab: "corporate-information", sectionId: "lp-theme-detail-corporate-information", prefix: "corp" },
    2: { tab: "delivery", sectionId: "lp-theme-detail-delivery", prefix: "del" },
    3: { tab: "exchange-returns", sectionId: "lp-theme-detail-exchange-returns", prefix: "ret" },
    4: { tab: "orders", sectionId: "lp-theme-detail-orders", prefix: "ord" },
    5: { tab: "products", sectionId: "lp-theme-detail-products", prefix: "pro" },
    6: { tab: "services", sectionId: "lp-theme-detail-services", prefix: "ser" }
  };

  const getThemeInfoFromQuestionNumber = (questionNumber) => {
    const parts = String(questionNumber).split(".");
    const main = parseInt(parts[0], 10);
    const sub = parseInt(parts[1], 10);
    if (!themeMapByMainNumber[main]) return null;

    const info = themeMapByMainNumber[main];
    return {
      themeTab: info.tab,
      detailSectionId: info.sectionId,
      accordionId: `${info.prefix}-a${sub}`
    };
  };

  const scrollToTop = () => {
    if (typeof window.scrollProxyTo === "function") {
      window.scrollProxyTo(0, "smooth");
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openAccordion = (accordionEl) => {
    const details = accordionEl.querySelector("details");
    const summary = accordionEl.querySelector("summary");

    accordionEl.scrollIntoView({ behavior: "smooth", block: "center" });

    setTimeout(() => {
      if (details && !details.open) {
        if (summary) summary.click();
        details.open = true;
        accordionEl.classList.add("is-open");
      }
    }, 250);
  };

  const goToQuestion = (questionNumber) => {
    const info = getThemeInfoFromQuestionNumber(questionNumber);
    if (!info) return;

    scrollToTop();

    const themeCard = document.querySelector(`[data-theme-tab="${info.themeTab}"]`);
    if (themeCard) themeCard.click();

    setTimeout(() => {
      const targetSection = document.getElementById(info.detailSectionId);
      if (!targetSection) return;

      const targetAccordion = targetSection.querySelector(`#${info.accordionId}`);
      if (!targetAccordion) return;

      openAccordion(targetAccordion);
    }, 650);
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-featured-question]");
    if (!btn) return;
    e.preventDefault();
    goToQuestion(btn.getAttribute("data-featured-question"));
  });
})();

(() => {
  const openLegalSupportTabFromHash = () => {
    if (window.location.hash !== "#support") return;

    const supportTab = document.querySelector('[data-legal-tab="support"]');
    if (supportTab) supportTab.click();

    if (typeof window.scrollProxyTo === "function") {
      window.scrollProxyTo(0, "smooth");
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openLegalSupportTabFromHash);
  } else {
    openLegalSupportTabFromHash();
  }

  window.addEventListener("hashchange", openLegalSupportTabFromHash);
})();

(() => {
  const openLegalTabFromHash = () => {
    const hash = window.location.hash;

    if (hash !== "#support" && hash !== "#faqs") return;

    const key = hash === "#support" ? "support" : "faqs";
    const tabBtn = document.querySelector('[data-legal-tab="' + key + '"]');
    if (tabBtn) tabBtn.click();

    if (typeof window.scrollProxyTo === "function") {
      window.scrollProxyTo(0, "smooth");
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openLegalTabFromHash);
  } else {
    openLegalTabFromHash();
  }

  window.addEventListener("hashchange", openLegalTabFromHash);
})();

  (function () {
    const trigger = document.getElementById("legal-search-trigger");
    if (!trigger) return;

    const isSupportActive = () => {
      const supportPanel = document.getElementById("legal-panel-support");
      if (supportPanel && supportPanel.getAttribute("data-active") === "true") return true;

      const supportTab = document.querySelector('[data-legal-tab="support"][aria-selected="true"]');
      if (supportTab) return true;

      const hash = (window.location.hash || "").toLowerCase();
      if (hash === "#support") return true;

      return false;
    };

    const update = () => {
      trigger.style.setProperty("display", isSupportActive() ? "none" : "", "important");
    };

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-legal-tab]")) {
        setTimeout(update, 0);
      }
    }, true);

    const panels = document.getElementById("legal-panels");
    if (panels) {
      new MutationObserver(() => update()).observe(panels, {
        subtree: true,
        attributes: true,
        attributeFilter: ["data-active"]
      });
    }

    window.addEventListener("hashchange", update);

    update();
  })();